import styled from "styled-components";

export const JackpotBetPrizeContainerDefaultBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 85%;
  margin: 1rem auto;
  
  box-shadow: 0 8px 36px 0 #0000002B,
  inset 0 0 6px 0 #7FF800,
  0 2px 2px 0 #1F086180,
  0 0 8.7px 0 #0000007A,
  inset 0 0 12px 0 #0000007A;
  
  background-color: #0000003A;
  
  border-radius: 20px;
  border: 1px solid #7FF800;
  padding: 4px 12px;
  
  align-items: center;

  & .fade-in {
    opacity: 1;
  }

  & .fade-out {
    opacity: 0;
  }

  & .fade-in-amount {
    opacity: 1;
    transform: translateX(0);
  }

  & .fade-out-amount {
    opacity: 0;
    transform: translateX(20px);
  }
`;
